import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import tw from "tailwind-styled-components";
import Table from "../../Components/ExtraCharges/Table";
import {
  BoxContainer,
  BoxTitle,
  BoxHead,
  Underline,
  FilterTableWrapper,
  FilterWrapper,
} from "../../Components/Styles/PageStyles";
// import AddExtraCharges from "../../Components/ExtraCharges/AddExtraCharges";
import { useSelector } from "react-redux";
import { useMutation, useQuery } from "react-query";
import axios from "axios";
import Config from "../../Config";
import { toast } from "react-toastify";
import EditExtraCharges from "../../Components/ExtraCharges/EditExtraCharges";
import Loading from "../../Components/Loading";
import NotFoundModel from "../../Components/NotFoundModel";
import DeleteCharges from "../../Components/ExtraCharges/DeleteCharges";
import SideModal from "../../Components/SideModal";
import LinkUnlinkProps from "../../Components/ExtraCharges/LinkUnlinkProps";
import CommonAddExtraCharges from "../../Components/Common/CommonAddExtraCharges";

const ExtraCharges = () => {
  const user = useSelector((state) => state.UserReducer.user);
  const property = useSelector(
    (state) => state.SelectPropertyReducer.selectProperty
  );
  const propId = property.id;
  const propertyList = useSelector((state) => state.PropertyReducer.property);
  const [apiData, setApiData] = useState();
  const { t, i18n } = useTranslation();
  const [isEditExtraCharges, setIsEditExtraCharges] = useState(false);
  const [isAddExtraCharges, setIsAddExtraCharges] = useState(false);
  const [isDeleteCharges, setIsDeleteCharges] = useState(false);
  const [selectedData, setSelectedData] = useState("");
  const query = propId ? `&propId=${property?.id}` : "";
  const [showLinkUnlinkModel, setShowLinkUnlinkModel] = useState(false);

  const fetchFunction = async () => {
    const response = await axios.get(
      `${Config.apiUrl}/extra-charges/web/list?${query}`,
      {
        headers: {
          authorization: "Bearer" + " " + user.token,
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
      }
    );
    return response.data;
  };

  const getSuccess = (res) => {
    if (res.isSuccess === false) error = true;
    else {
      setApiData(res?.data);
      //setSummary(res?.stats);
    }
  };

  const getError = (res) => { };

  const {
    isLoading: isLoading,
    mutate: getListMutate,
    error,
    data,
    isRefetching,
    refetch,
  } = useMutation(fetchFunction, {
    onSuccess: getSuccess,
    onError: getError,
  });

  useEffect(() => {
    const handler = setTimeout(() => {
      getListMutate();
    }, 500);

    return () => {
      clearTimeout(handler);
    };
  }, [property]);

  //------- Add Extra Charges -------
  const addExtraChargesFunction = async (values) => {
    return await axios.post(`${Config.apiUrl}/extra-charges/add`, values, {
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${user.token}`,
      },
    });
  };

  const addExtraChargesSuccess = (data) => {
    setIsAddExtraCharges(false);
    getListMutate();
    toast.success(data?.data?.msg || "Success");
  };

  const addExtraChargesError = (data) => {
    setIsAddExtraCharges(false);
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: addExtraChargesLoading, mutate: addExtraChargesMutate } =
    useMutation(addExtraChargesFunction, {
      onSuccess: addExtraChargesSuccess,
      onError: addExtraChargesError,
    });

  //------- Edit Extra Charges -------
  const editExtraChargesFunction = async (values) => {
    return await axios.post(`${Config.apiUrl}/extra-charges/edit`, values, {
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${user.token}`,
      },
    });
  };

  const editExtraChargesSuccess = (data) => {
    setIsEditExtraCharges(false);
    getListMutate();
    toast.success(data?.data?.msg || "Success");
  };

  const editExtraChargesError = (data) => {
    setIsEditExtraCharges(false);
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: editExtraChargesLoading, mutate: editExtraChargesMutate } =
    useMutation(editExtraChargesFunction, {
      onSuccess: editExtraChargesSuccess,
      onError: editExtraChargesError,
    });

  //------- Delete Extra Charges -------
  const deleteExtraChargesFunction = async (values) => {
    return await axios.post(`${Config.apiUrl}/extra-charges/delete`, values, {
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${user.token}`,
      },
    });
  };

  const deleteExtraChargesSuccess = (data) => {
    setIsDeleteCharges(false);
    getListMutate();
    toast.success(data?.data?.msg || "Success");
  };

  const deleteExtraChargesError = (data) => {
    setIsDeleteCharges(false);
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: deleteChargesLoading, mutate: deleteChargesMutate } =
    useMutation(deleteExtraChargesFunction, {
      onSuccess: deleteExtraChargesSuccess,
      onError: deleteExtraChargesError,
    });

  const handleExtraChargesClose = () => {
    setIsEditExtraCharges(false);
  };

  const handleAddExtraChargesClose = () => {
    setIsAddExtraCharges(false);
  };

  //------- Link Property  -------
  const linkPropertyFunction = async (values) => {
    return await axios.post(`${Config.apiUrl}/extra-charges/toggle/new`, values, {
      headers: {
        authorization: "Bearer" + " " + user.token,
        "Content-Type": "application/json",
      },
    });
  };
  const onLinkPropertyeSuccess = (data) => {
    if (data?.data?.isSuccess === true) {
      toast.success(data?.data?.msg || "Success");
      setShowLinkUnlinkModel(false);
      getListMutate();
    } else {
      toast.error(data?.rdata?.msg || "An Error Occured");
    }
  };

  const onLinkPropertyError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const {
    isLoading: linkPropertyLoading,
    mutate: linkPropertyMutate,
  } = useMutation(linkPropertyFunction, {
    onSuccess: onLinkPropertyeSuccess,
    onError: onLinkPropertyError,
  });

  return (
    <BoxContainer>
      <BoxHead>
        <BoxTitle className="!mb-0 whitespace-nowrap">
          Extra Charges
          <Underline />
        </BoxTitle>
        <ApplyBtn
          type="button"
          onClick={() => {
            setIsAddExtraCharges(true);
          }}
        >
          {"Add Charges"}
        </ApplyBtn>
      </BoxHead>

      <SideModal
        isOpen={isEditExtraCharges}
        onClose={() => setIsEditExtraCharges(false)}
      >
        <EditExtraCharges
          setIsEditExtraCharges={setIsEditExtraCharges}
          isEditExtraCharges={isEditExtraCharges}
          handleClose={handleExtraChargesClose}
          editExtraChargesMutate={editExtraChargesMutate}
          editExtraChargesLoading={editExtraChargesLoading}
          selectedData={selectedData}
          propId={propId}
        />
      </SideModal>

      <SideModal
        isOpen={showLinkUnlinkModel}
        onClose={() => setShowLinkUnlinkModel(false)}
      >
        <LinkUnlinkProps
          setShowLinkUnlinkModel={setShowLinkUnlinkModel}
          //linkStaff={linkStaff}
          linkPropertyLoading={linkPropertyLoading}
          linkPropertyMutate={linkPropertyMutate}
          properties={propertyList}
          selectedData={selectedData}
        />
      </SideModal>

      <SideModal
        isOpen={isAddExtraCharges}
        onClose={() => setIsAddExtraCharges(false)}
      >
        {/* <AddExtraCharges
          setIsAddExtraCharges={setIsAddExtraCharges}
          isAddExtraCharges={isAddExtraCharges}
          handleClose={handleAddExtraChargesClose}
          addExtraChargesLoading={addExtraChargesLoading}
          addExtraChargesMutate={addExtraChargesMutate}
          propId={propId}
          property={propertyList}
        /> */}
        <CommonAddExtraCharges
          handleClose={handleAddExtraChargesClose}
          addExtraChargesLoading={addExtraChargesLoading}
          addExtraChargesMutate={addExtraChargesMutate}
          propId={propId}
          property={propertyList}
          modalType="PROPERTY_SELECT"
        />
      </SideModal>

      {isDeleteCharges && (
        <DeleteCharges
          setIsDeleteCharges={setIsDeleteCharges}
          deleteChargesLoading={deleteChargesLoading}
          deleteChargesMutate={deleteChargesMutate}
          selectedData={selectedData}
        />
      )}

      <FilterTableWrapper>
        <FilterWrapper>
          <div className="flex items-center">
            <Text>
              Total records:{" "}
              <span className="font-semibold">
                {apiData?.length || 0}
              </span>
            </Text>
          </div>
        </FilterWrapper>
        {!error && !isLoading && data && (
          <TableWrapper>
            <Table
              apiData={error ? [] : apiData}
              setIsEditExtraCharges={setIsEditExtraCharges}
              setShowLinkUnlinkModel={setShowLinkUnlinkModel}
              selectedData={selectedData}
              setSelectedData={setSelectedData}
              setIsDeleteCharges={setIsDeleteCharges}
            />
            {(error || apiData.length === 0) && !isLoading && (
              <NotFoundModel msg={"No Extra charges found"} />
            )}
          </TableWrapper>
        )}
      </FilterTableWrapper>
      {(isLoading || isRefetching) && <Loading />}
    </BoxContainer>
  );
};

const TableWrapper = tw.h1`mt-4 bg-white rounded-md `;
const ApplyBtn = tw.button`${(p) =>
  p.$active
    ? "bg-gray-100"
    : ""} border whitespace-nowrap border-gray-200 flex space-x-1.5 justify-center items-center text-white h-full rounded-md px-6  cursor-pointer bg-gradient-to-r from-primary-color to-[#00A0FF] hover:brightness-110 py-2.5 text-sm`;
const Text = tw.p`text-gray-500 text-sm font-normal `;

export default ExtraCharges;
